import type { HTMLAttributes } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

type Props = HTMLAttributes<HTMLDivElement> & {
  color: 'primary' | 'success' | 'warning' | 'critical' | 'neutral';
  label?: string;
  placement?: 'left' | 'right';
};
export const Dot = ({ color, label, placement = 'left', ...rest }: Props) => {
  const style = css`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${getColor(color)};
  `;

  return label ? (
    <span {...rest}>
      {placement === 'right' && <Text as={'span'}>{label}</Text>}
      <span
        css={[
          style,
          css`
            display: inline-block;
          `,
          placement === 'left'
            ? css`
                margin-right: ${theme.spacing(1)};
              `
            : css`
                margin-left: ${theme.spacing(1)};
              `,
        ]}
      />
      {placement === 'left' && <Text as={'span'}>{label}</Text>}
    </span>
  ) : (
    <span css={style} />
  );
};

const getColor = (color: Props['color']) => {
  switch (color) {
    case 'primary':
      return theme.colors.primary[50];
    case 'success':
      return theme.colors.success[30];
    case 'warning':
      return theme.colors.warning[50];
    case 'critical':
      return theme.colors.critical[50];
    case 'neutral':
      return theme.colors.neutral[50];
  }
};
